export default {
  bucketName: {
    title: 'Bucket Name',
    message: 'By setting the bucket name on External Account creation, you agree on managing this bucket only. Hereby file listing, object managemet nor creation will be available for other buckets with this account.',
  },

}
